import { type PlanLevel } from '~/lib/.client/plans';
import { requestWithAuth } from '~/lib/.client/request-with-auth';
import { CLIENT_ORIGIN } from '~/lib/constants';
import { SHOW_PRICING_OVERLAY_PARAM, SUBSCRIPTION_UPDATE_SEARCH_PARAM } from '~/lib/stores/pricing/config';
import { PRICING_URL } from '~/lib/urls';
import type { SubscriptionInterval } from '~/types/subscription';
import { invariant } from '~/utils/invariant';

const requestSubscriptionWithAuth = requestWithAuth(CLIENT_ORIGIN);

function getPricingRedirectUrl() {
  const url = new URL(window.location.href);

  const redirectUrl = url.pathname === PRICING_URL ? new URL(url.origin) : url;

  redirectUrl.searchParams.set(SUBSCRIPTION_UPDATE_SEARCH_PARAM, 'true');

  if (url.pathname === PRICING_URL) {
    /**
     * If we update subscription from the pricing page, we need to redirect to main page with showPricing=true
     * (which opens pricing overlay)
     */
    redirectUrl.searchParams.set(SHOW_PRICING_OVERLAY_PARAM, 'true');
  }

  return url.toString();
}

export async function createProCheckoutSession(
  level: PlanLevel,
  interval: SubscriptionInterval,
  freeTrialParam?: string,
) {
  const redirectUrl = getPricingRedirectUrl();

  let apiUrl = `api/membership/${level}/${interval}`;

  if (freeTrialParam) {
    apiUrl += `?free_trial=${encodeURIComponent(freeTrialParam)}`;
  }

  const response = await requestSubscriptionWithAuth<{ sessionUrl: string }>(
    apiUrl,
    { success_url: redirectUrl, cancel_url: redirectUrl },
    'POST',
  );

  const sessionUrl = response?.sessionUrl;

  invariant(sessionUrl);

  return sessionUrl;
}
